module.exports = __webpack_public_path__ + "img/arrastrar.9bc97ba7.svg";